import { render, staticRenderFns } from "./userStoryDetail.vue?vue&type=template&id=446716e5&scoped=true&"
import script from "./userStoryDetail.vue?vue&type=script&lang=ts&"
export * from "./userStoryDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446716e5",
  null
  
)

export default component.exports